import { cn } from "@/lib/cn"
import { SVGIcon } from "@/types/icon"
import React from "react"

const ServerIcon: React.FC<SVGIcon> = ({ className, ...props }) => {
  return (
    <svg
      {...props}
      className={cn(className)}
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 47}
      height={props?.width ?? 46}
      viewBox="0 0 47 46"
      fill="none">
      <path
        d="M12 11.9792V15.8125"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.6667 23V17.25C42.6667 7.66665 38.8333 3.83331 29.25 3.83331H17.75C8.16668 3.83331 4.33334 7.66665 4.33334 17.25V28.75C4.33334 38.3333 8.16668 42.1666 17.75 42.1666H23.5"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6667 11.9792V15.8125"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 30.6667V34.5"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6667 30.6667V34.5"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.3333 13.8958H35"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33334 23H42.6667"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.8233 38.9659C40.75 40.825 38.7375 42.0708 36.4375 42.0708C33.0067 42.0708 30.8983 38.6208 30.8983 38.6208M31.0325 32.7558C32.1058 30.8775 34.1183 29.6317 36.4375 29.6317C40.5967 29.6317 42.6667 33.0817 42.6667 33.0817M42.6667 29.2292V33.0625H38.8333M34.7316 38.6017H30.8983V42.1667"
        stroke={props?.stroke ?? "#640EF1"}
        strokeWidth={props?.strokeWidth ?? 3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { ServerIcon }
